<template>
    <Teleport to="body">
        <Transition name="fade">
            <div 
                v-if="abrirModal" 
                class="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/50"
                @click.self="closeModal">
                <Transition name="scale">
                    <div 
                        v-if="abrirModal"
                        class="relative bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full p-6 border border-gray-200 dark:border-slate-700"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="modal-title">
                        
                        <!-- Icon -->
                        <div class="flex justify-center mb-4">
                            <div class="relative w-16 h-16">
                                <div class="absolute inset-0 bg-orange-100 dark:bg-orange-900/30 rounded-full"></div>
                                <div class="absolute inset-2 bg-orange-200 dark:bg-orange-800/40 rounded-full"></div>
                                <div class="absolute inset-0 flex items-center justify-center">
                                    <div class="w-10 h-10 border-2 border-orange-500 dark:border-orange-400 rounded-full flex items-center justify-center">
                                        <span class="text-2xl font-bold text-orange-500 dark:text-orange-400">!</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Title -->
                        <h4 
                            id="modal-title"
                            class="text-xl font-semibold text-center mb-3 text-gray-900 dark:text-gray-100">
                            Atenção!
                        </h4>

                        <!-- Body -->
                        <div class="text-center text-gray-600 dark:text-gray-400 mb-6 space-y-2">
                            <p>{{ mensagem }}</p>
                            <p v-if="mensagensComplementares">
                                Verifique se digitou corretamente e tente novamente.
                            </p>
                            <p v-if="mensagensComplementares">
                                Caso ainda não tenha uma conta, clique em 
                                <router-link 
                                    to="/CadastroInicio" 
                                    class="font-medium text-blue-600 dark:text-blue-400 hover:underline">
                                    Cadastre-se
                                </router-link> 
                                para criar um novo cadastro.
                            </p>
                        </div>

                        <!-- Footer -->
                        <button
                            @click="closeModal"
                            class="w-full py-2.5 px-4 rounded-lg text-white transition-colors font-medium bg-gray-500 hover:bg-gray-600 dark:bg-gray-600 dark:hover:bg-gray-700">
                            Entendi
                        </button>
                    </div>
                </Transition>
            </div>
        </Transition>
    </Teleport>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: ['mensagem', 'mensagensComplementares'],
    computed: {
        ...mapGetters({
            abrirModal: 'GET_MODAL_AVISO_LOGIN'
        })
    },
    methods: {
        closeModal() {
            this.$store.commit('SET_MODAL_AVISO_LOGIN', false);
        }
    }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.scale-enter-active,
.scale-leave-active {
  transition: all 0.2s ease;
}

.scale-enter-from,
.scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>